<template>
  <div class="field-wrapper field-wrapper--text field-wrapper--large"
       :class="[field.cssClass, {'visually-hidden': field.visibility === 'hidden'}]">
    <div class="field-group field-group--block"
         :class="[{'field-group--is-error': isError}, {'field-group--block-animated': time}]">
      <label
        class="label"
        :for="'input_' + field.id"
        :class="[{'visually-hidden': field.labelPlacement === 'hidden_label'}]"
      >
        {{ field.label }}<sup v-if="field.isRequired">*</sup>
      </label>

      <flat-pickr
          ref="flatpickr"
          :id="'input_' + field.id"
          :name="'input_' + field.id"
          v-model="time"
          :config="timePicker"
          class="input-date"
          :required="field.isRequired"
          placeholder="">
      </flat-pickr>
    </div>

    <slot name="description"></slot>
    <slot name="error"></slot>
  </div>
</template>

<script>
import store from '../store';
import VFieldMixins from './VFieldMixins.vue';
import flatPickr from 'vue-flatpickr-component';

export default {
  store,
  name: "VFieldTime.vue",
  mixins: [VFieldMixins],
  data () {
    return {
      time: '',
      timePicker: {
        enableTime: true,
        noCalendar: true,
        altInput: true,
        altFormat: "H:i",
        time_24hr: true,
        disableMobile: true,
        allowInput: true, // enable html5 validation
        defaultHour: 8,
        onOpen: (selectedDates, dateStr, instance) => {
          instance.altInput.setAttribute("readonly", true)
          this.time = '08:00';
        },
        onClose: (selectedDates, dateStr, instance) => {
          instance.altInput.setAttribute("readonly", false)
          instance.altInput.blur();
        },
      }
    }
  },

  components: {
    flatPickr
  },

  props: {
    formId: Number,
    field: Object,
    fieldKey: Number,
    isError: String
  },

  watch: {
    time: {
      immediate: true,
      deep: false,
      handler (newValue) {
        store.commit(
            'UPDATE_USER_FORM_DATA' ,
            {'key': this.field.id, 'value': newValue})
      }
    }
  }
}
</script>
